var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarUploadBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8665 9.33297H5.9865V15.9996C5.9865 16.733 6.5865 17.333 7.31984 17.333H12.6532C13.3865 17.333 13.9865 16.733 13.9865 15.9996V9.33297H16.1065C17.2932 9.33297 17.8932 7.89297 17.0532 7.05297L10.9332 0.932969C10.4132 0.412969 9.57317 0.412969 9.05317 0.932969L2.93317 7.05297C2.09317 7.89297 2.67984 9.33297 3.8665 9.33297ZM0.666504 21.333C0.666504 22.0663 1.2665 22.6663 1.99984 22.6663H17.9998C18.7332 22.6663 19.3332 22.0663 19.3332 21.333C19.3332 20.5996 18.7332 19.9996 17.9998 19.9996H1.99984C1.2665 19.9996 0.666504 20.5996 0.666504 21.333Z",
    fill: "#077CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarUploadBlue);
export default __webpack_public_path__ + "static/media/sidebar_upload_blue.63b654af546d5aa348f2dd6f9cd4c4e4.svg";
export { ForwardRef as ReactComponent };